import React from "react";
import {connect} from "react-redux";
import {updatePage} from "../../actions/page";
import AccessGate from "../../components/permissions/AccessGate";
import {DEFAULT_DOMAINS_PER_PAGE} from "../../config";
import {displayErrors} from "../../libs/utils";
import {Alert, Card, Col, ConfigProvider, Row, Select, Space, Table, Tag, Tooltip} from "antd";
import AccessItem from "../../components/permissions/AccessItem";
import Button from "antd/es/button";
import PlusOutlined from "@ant-design/icons/lib/icons/PlusOutlined";
import UndoOutlined from "@ant-design/icons/lib/icons/UndoOutlined";
import {FolderOpenOutlined} from "@ant-design/icons";
import {DateTimeFormat} from "../../components/shared/DateTimeFormat";
import {Link} from "react-router-dom";
import {getWMRProjects} from "../../actions/wayback_machine_restoration";
import {StatusIndicator} from "../../components/shared/Status";
import WaybackMachineRestorationAddProjectModal
    from "../../components/wayback_machine_restoration/WaybackMachineRestorationAddProjectModal";

class WaybackMachineRestorationProjects extends React.Component {
    state = {
        projects: [],
        filters: null,
        showAddModal: false,
        searchQuery: [],
        searching: false,
        showAddProjectModal: false,
        loading: false,
        pagination: { current: 1, pageSize: DEFAULT_DOMAINS_PER_PAGE, showSizeChanger: true, total: 0 }
    };

    componentDidMount() {
        this.props.updatePage(<span>Projects <Tag color='warning'>Beta</Tag></span>);
        this.loadProjects();
    }

    loadProjects(page = null, per_page = null, filters = null) {
        if(page === null) {
            page = this.state.pagination.current;
        }

        if(per_page === null) {
            per_page = this.state.pagination.pageSize;
        } else {
            if(per_page !== this.state.pagination.pageSize) {
                page = 1;
            }
        }

        if(filters === null) {
            filters = this.state.filters;
        }

        if(this.state.searchQuery.length > 0) {
            page = 1;
            this.setState({ searching: true });
        }

        this.setState({ loading: true });

        this.props.getWMRProjects(page, per_page, this.state.searchQuery, filters, (response) => {
            this.setState({ projects: response.data.data,
                pagination: { current: response.data.page, pageSize: response.data.per_page, showSizeChanger: true, total: response.data.total }, loading: false, searching: false });
        }, (err) => {
            this.setState({ loading: false, searching: false });

            if(typeof err.response !== 'undefined') {
                displayErrors(err.response.data);
            }
        });
    }

    clearSearchAndLoadProjects() {
        this.setState({ searchQuery: []}, () => {
            this.loadProjects();
        });
    }

    runSearch() {
        if(this.state.searchQuery.length > 0) {
            this.loadProjects();
        }
    }

    updateSearchQuery(value) {
        if(value.length === 0) {
            return this.setState({ searchQuery: [] }, () => this.loadProjects());
        }

        let query = [];

        for(let i = 0; i < value.length; i++) {
            let item = value[i].trim();

            if(item !== '') {
                query.push(item)
            }
        }

        this.setState({ searchQuery: query });

        if(query.length === 0) {
            this.loadProjects();
        }
    }

    render() {
        const columns = [
            { title: 'Domain', dataIndex: 'domain', width: '30%', render: (item, record) => <Link to={'/website-restoration/' + record.guid}>{item.domain}</Link> },
            { title: 'Created', dataIndex: 'date_created', render: (item) => <DateTimeFormat value={item} /> },
            { title: 'Completed', dataIndex: 'date_completed', render: (item) => item === null ? '-' : <DateTimeFormat value={item} /> },
            { title: 'Status', dataIndex: 'status', render: (item) => <StatusIndicator el='badge' status={item} /> },
        ];

        if(this.props.company.domain_count === 0) {
            return <Alert type='info' showIcon message='Please add domains to your account before creating a restoration project!' />
        }

        return <AccessGate scopes={['can_use_wayback_machine_restoration']}>
            <Card size='small'>
                <Row justify='space-between' style={{paddingBottom: '10px'}}>
                    <Col>
                        <Space>
                            <AccessItem scopes={['can_use_wayback_machine_restoration']}>
                                <Button className='add-domain-group-btn' icon={<PlusOutlined />}
                                        onClick={() => this.setState({ showAddProjectModal: true })}>Add Project</Button>
                            </AccessItem>

                            <Select
                                value={this.state.searchQuery}
                                maxTagCount={50}
                                placeholder='Search...'
                                open={false}
                                maxTagTextLength={10}
                                onClear={() => this.clearSearchAndLoadProjects()}
                                onInputKeyDown={(e) => { if(e.key === 'Enter') { this.runSearch() }}}
                                allowClear loading={this.state.searching}
                                mode="tags" style={{ width: '250px' }}
                                onChange={(value) => this.updateSearchQuery(value)} tokenSeparators={[',', ' ']} />
                        </Space>
                    </Col>
                    <Col>
                        <Tooltip title='Reload table'>
                            <Button type='text' icon={<UndoOutlined />} onClick={() => this.loadProjects()}/>
                        </Tooltip>
                    </Col>
                </Row>

                <ConfigProvider renderEmpty={() => <div style={{textAlign: 'center'}}>
                    <FolderOpenOutlined style={{fontSize: 40}}/>
                    <p>Nothing to see here...</p>
                    <AccessItem scopes={['can_use_wayback_machine_restoration']}>
                        <Button icon={<PlusOutlined/>} onClick={() => this.setState({ showAddProjectModal: true })}>Add Project</Button>
                    </AccessItem>
                </div>}>
                    <div style={{overflowX: 'auto'}}>
                        <Table
                            dataSource={this.state.projects}
                            columns={columns}
                            rowKey={(item) => item.guid}
                            pagination={this.state.pagination}
                            onChange={(pagination) => this.loadProjects(pagination.current, pagination.pageSize)}
                            loading={this.state.loading}/>
                    </div>
                </ConfigProvider>
            </Card>

            <WaybackMachineRestorationAddProjectModal
                history={this.props.history}
                showModal={this.state.showAddProjectModal}
                close={() => this.setState({ showAddProjectModal: false })}
                reload={() => this.loadProjects()}  />
        </AccessGate>;
    }
}

const mapStateToProps = state => ({
    company: state.auth.user.user.company
});

export default connect(mapStateToProps, { updatePage, getWMRProjects })(WaybackMachineRestorationProjects);